import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class InputRows extends BaseOption {
  static userInterfaceComponent = {
    label: "Rows",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = 6;
}
